<mat-dialog-content
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <div
    class="
      tw-flex
      tw-justify-end
      tw-absolute
      tw-top-[0px]
      tw-right-[0px]
      tw-cursor-pointer
      !tw-mt-[2px]
      tw-mr-[5px]
    "
  >
    <mat-icon (click)="closeDialog()">close</mat-icon>
  </div>

  @if (liveVideoUrl) {
    <iframe
      #streamVideo
      class="live-video tw-mt-[10px]"
      [src]="liveVideoUrl | sanitizer"
      width="100%"
      height="243px"
      frameborder="0"
      scrolling="no"
      allowfullscreen="true"
      allow="autoplay"
    >
    </iframe>
  }
</mat-dialog-content>